"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../hooks");
const inputs_1 = require("../../../inputs");
exports.ContentImportPanelToolbarSearch = () => {
    const { contentFeed } = hooks_1.useContentImportPanelData();
    const { onChangeContentFeed } = hooks_1.useContentImportPanelUpdate();
    return (react_2.default.createElement(react_1.OsmosysDiv, { osysName: "ContentImportPanel.toolbar.left", flexFill: true, className: "overflow-hidden", padding: "sm" },
        react_2.default.createElement(inputs_1.OsmosysResourceSelectBox, { resource: "contentFeed", label: false, value: contentFeed, onChange: onChangeContentFeed, selectFirstIfNoValue: false, fetchPolicy: "no-cache" // WITHOUT THIS, THE CONTENT WILL REVERT WHEN CLICKING CLEAR, THEN IMPORT CONTENT
         })));
};
//# sourceMappingURL=Search.js.map